'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  allEvents: 'All Events',
  audiences: 'Audiences',
  clearFilters: 'Remove all search criteria',
  contact: 'Contact',
  directions: 'Directions',
  groups: 'Presented by',
  nextPage: 'Next Page',
  noEvents: 'No events.',
  otherDates: 'other date |||| other dates',
  previousPage: 'Previous Page',
  price: 'Price',
  save: 'Save',
  share: 'Share',
  tags: 'Tags',
  tickets: 'Tickets',
  venueMap: 'Venue Map',
  weekOf: 'Week of',
  date: {
    from: 'from',
    to: 'to'
  },
  time: {
    rangeDelimiter: 'to'
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/locales/en.js
// module id = 635
// module chunks = 0